import {createI18nScope} from 'common/i18n/scope';

const __i18nScope = createI18nScope(`common.report.util.boards`, {
  'boards.actions.duplicate': `Duplicate`,
  'boards.actions.linked-copy': `Create Linked Copy`,
  'boards.cards.actions.add-to-new-board': `Place in New Board`,
  'boards.cards.actions.duplicate-placeholder': `Add report to another board...`,
  'boards.cards.actions.move-placeholder': `Move report to another board...`,
  'reports.actions.data-age-hour': `Data from {{minutes}} min ago`,
  'reports.actions.data-age-old': `Data from {{time}}`,
  'reports.actions.data-age-recent': `Data from < 1 min ago`,
  'reports.actions.move-to-board': `Move to New Board`,
});

__i18nScope.registerTranslationLoaders({"es": () => import("virtual:i18n-scope/es/common.report.util.boards"), "fr": () => import("virtual:i18n-scope/fr/common.report.util.boards"), "id": () => import("virtual:i18n-scope/id/common.report.util.boards"), "ja": () => import("virtual:i18n-scope/ja/common.report.util.boards"), "ko": () => import("virtual:i18n-scope/ko/common.report.util.boards"), "pt": () => import("virtual:i18n-scope/pt/common.report.util.boards"), "zh-CN": () => import("virtual:i18n-scope/zh-CN/common.report.util.boards"), "zh-TW": () => import("virtual:i18n-scope/zh-TW/common.report.util.boards")});
export default __i18nScope;
